export default function throttle(functionToThrottle, threshhold, scope) {
  let last, deferTimer;

  return function throttle() {
    const context = scope || this;
    const now = +new Date();
    const args = arguments;

    if (last && now < last + threshhold) {
      clearTimeout(deferTimer);

      deferTimer = setTimeout(() => {
        last = now;
        functionToThrottle.apply(context, args);
      }, threshhold + last - now);
    } else {
      last = now;
      functionToThrottle.apply(context, args);
    }
  };
}
